import style from "./style.scss";

import { mergeClasses } from "../helpers";
import Link from "../link";
import NoWrap from "../no-wrap";

const CandidateItem = ({ img, name, email, url }) => (
  <li class={style.candidateItem}>
    <Link class={style.image} href={url}>
      <img src={img} alt={name} />
    </Link>
    <div class={style.info}>
      <div class={style.textWrapper}>
        <h3>{name}</h3>
        <div class={style.since}>Candidate for Klahanie Board of Directors</div>
        <Link
          class={mergeClasses([style.email, style.fullEmail])}
          rel="noreferrer"
          href={`mailto:${email}`}
        >
          {email}
        </Link>
        <Link
          class={mergeClasses([style.email, style.emailMe])}
          rel="noreferrer"
          href={`mailto:${email}`}
        >
          Email me
        </Link>
      </div>
      <div class={style.buttonWrapper}>
        <Link class="button" href={url}>
          View Bio
        </Link>
      </div>
    </div>
  </li>
);

export default CandidateItem;
